import React from 'react';
import {
    SP_SKIP, extractResponseData, SmartStyles, SmartHeader, SmartSection, NoRecordsCard, RawResponseButton
} from './_SmartFieldRenderer';

const GROUPS = {
    location:  { title: 'LOCATION',     icon: 'pi-map-marker',  keys: ['district', 'taluka', 'hobli', 'village', 'khata_no', 'khata_number', 'survey_number'] },
    ownership: { title: 'OWNERSHIP',    icon: 'pi-users',       keys: ['owner_name', 'owners', 'owner_names'] },
    details:   { title: 'LAND DETAILS', icon: 'pi-info-circle', keys: ['land_type', 'area', 'area_unit', 'cultivator', 'land_use', 'total_area'] },
};

const HIGHLIGHT = ['khata_no', 'khata_number'];

const KarnatakaLandVerificationOutputComponent = ({ reportData, hideCredits, isSharedView }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) return <NoRecordsCard subtitle="No data available" />;
    if (!responseData || !hasRealData) {
        return <NoRecordsCard errorMsg={errorMsg} subtitle="No records found for the provided details. Please verify and try again." />;
    }

    const d = responseData;
    const grouped = {};
    for (const [groupName, group] of Object.entries(GROUPS)) {
        const picked = {};
        group.keys.forEach(k => { if (k in d && d[k] !== null && d[k] !== undefined && d[k] !== '') picked[k] = d[k]; });
        if (Object.keys(picked).length > 0) grouped[groupName] = picked;
    }
    const knownKeys = new Set(Object.values(GROUPS).flatMap(g => g.keys));
    const leftover = {};
    for (const [k, v] of Object.entries(d)) {
        if (SP_SKIP.has(k) || knownKeys.has(k)) continue;
        if (v === null || v === undefined || v === '') continue;
        leftover[k] = v;
    }

    return (
        <div>
            <SmartStyles />
            <SmartHeader title="Karnataka Land Verification Report" icon="pi-map" remainingBalance={remainingBalance} shouldHideCredits={shouldHideCredits} />
            <div className="horizontal-report-card">
                {Object.entries(GROUPS).map(([groupName, meta]) => (
                    grouped[groupName]
                        ? <SmartSection key={groupName} title={meta.title} icon={meta.icon} data={grouped[groupName]} highlightKeys={HIGHLIGHT} />
                        : null
                ))}
                {Object.keys(leftover).length > 0 && (
                    <SmartSection title="OTHER DETAILS" icon="pi-info-circle" data={leftover} />
                )}
                <RawResponseButton data={d} />
            </div>
        </div>
    );
};

export default KarnatakaLandVerificationOutputComponent;
